import api from './api';

const authService = {
  sendOtp: async (mobile) => {
    const response = await api.post('/auth/send-otp', { mobile });
    return response.data;
  },

  resendOtp: async (mobile) => {
    const response = await api.post('/auth/resend-otp', { mobile });
    return response.data;
  },

  verifyOtp: async (mobile, otp) => {
    const response = await api.post('/auth/verify-otp', { mobile, otp });
    return response.data;
  },

  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },
};

export default authService;
